import { getApiBaseUrl, getApiClient } from "./serviceconfig";

var apiBaseUrl = getApiBaseUrl();

export async function getAllMoisture(cookies, options = {}) {
  const params = new URLSearchParams();
  if (typeof options === 'string' && options) {
    params.set('name', options);
  } else if (options && typeof options === 'object') {
    if (options.searchString) {
      params.set('name', options.searchString);
    }
    if (options.plantId) {
      params.set('plant_id', options.plantId);
    }
    if (options.activeOnly) {
      params.set('active_only', 'true');
    }
    if (options.includeId) {
      params.set('include_id', options.includeId);
    }
  }
  const query = params.toString();
  const url = query
    ? `${apiBaseUrl}/moisture_correction/?${query}`
    : `${apiBaseUrl}/moisture_correction/`;
  return getApiClient(cookies).get(url).then((response) => response.data);
}

export async function getMoistureByPlant(cookies, plantId) {
  return getApiClient(cookies)
    .get(`${apiBaseUrl}/moisture_correction/by_plant/?plant_id=${plantId}`)
    .then((response) => response.data);
}

export async function getMoistureDailyCount(cookies, plantId) {
  return getApiClient(cookies)
    .get(`${apiBaseUrl}/moisture_correction/daily_count/?plant_id=${plantId}`)
    .then((response) => response.data);
}

export async function getMcNumber(cookies, plantId, mcDate = null, mcTime = null) {
  const params = new URLSearchParams({ plant_id: plantId });
  if (mcDate) {
    params.set('mc_date', mcDate);
  }
  if (mcTime) {
    params.set('mc_time', mcTime);
  }
  return getApiClient(cookies)
    .get(`${apiBaseUrl}/moisture_correction/mc_number/?${params.toString()}`)
    .then((response) => response.data);
}

export async function createMoisture(cookies, inputs) {
  return getApiClient(cookies)
    .post(`${apiBaseUrl}/moisture_correction/`, inputs)
    .then((response) => response.data);
}

export async function updateMoisture(cookies, inputs, moisture_id) {
  return getApiClient(cookies)
    .put(`${apiBaseUrl}/moisture_correction/${moisture_id}/`, inputs)
    .then((response) => response.data);
}

export async function getMoistureDetails(cookies, moisture_id) {
  return getApiClient(cookies)
    .get(`${apiBaseUrl}/moisture_correction/${moisture_id}/`)
    .then((response) => response.data);
}

export async function deleteMoisture(cookies, moisture_id) {
  return getApiClient(cookies).delete(
    `${apiBaseUrl}/moisture_correction/${moisture_id}/`
  );
}

export function printMoistureCorrection(cookies, moistureId) {
  return getApiClient(cookies).get(
    `${apiBaseUrl}/moisture_correction/${moistureId}/print_moisture_correction/`,
    { responseType: 'blob' },
  ).then((response) => response.data);
}